import React from 'react';
import CharterType from '../Form/CharterType';
import FormInput from '../Form/FormInput';
import BooleanInput from '../Form/BooleanInput';
import { useHistory } from 'react-router-dom';
import { Container, Row, Col, Input, FormGroup } from 'reactstrap';
import StringSelector from '../Form/StringSelector';
import { useAuth } from '../../Services/AuthContext';
import SupplierLocationSelector from '../Form/SupplierLocationSelector';
import { useEdit } from '../../Services/EditContext';
import { FormLabel, FormValue } from '../Form/FormLabel';
import { useFormikContext } from 'formik';
import { ISupplier } from '../../Models/ISupplier';
import { Button } from 'react-bootstrap';
import SecondaryEmails from '../EntityList/SecondaryEmails';
import DatePicker from '../Form/DatePicker'
import moment from 'moment';
import { ErrorMessage } from 'formik';

const SupplierFormInput = FormInput as (props:
    { id: keyof ISupplier, label: string, readOnly?: boolean, type?: string, maxLength?: number }) => JSX.Element;
const SupplierBooleanInput = BooleanInput as (props: { id: keyof ISupplier, label: string }) => JSX.Element;

interface props {
    invite?: boolean, route?: string
}

const Supplier = ({ invite, route = "" }: props) => {
    const [user] = useAuth();
    const [edit] = useEdit();
    const { location, push } = useHistory();
    const { values, setFieldValue } = useFormikContext() as unknown as
        { values: ISupplier, setFieldValue: (field: keyof ISupplier, value: unknown) => void };
    const { role } = user;
    const isAdmin = role === 'Admin';

    const handleChangeEmailLocationFilter = (e) => {
        setFieldValue('locationFilterEnabled', e.target.checked);
    }
    const handleChangePassengerRange = (e) => {
        setFieldValue('passengerRangeFilterEnabled', e.target.checked);
    }
    const minDate = moment().subtract(10, 'years').toDate();
    const maxDate = moment().toDate();
    const handleAocIssuedDateChange = (date: unknown) => {
        // Only accept Date or null
        let validDate: Date | null = null;
        if (date instanceof Date || date === null) {
            validDate = date;
        }
        setFieldValue('aocIssuedDate', validDate);
    }
    const handlePart138IssuedDateChange = (date: unknown) => {
        // Only accept Date or null
        let validDate: Date | null = null;
        if (date instanceof Date || date === null) {
            validDate = date;
        }
        setFieldValue('part138IssuedDate', validDate);
    }
     const isAdminOrSupplier=role==='Admin'||role==='Supplier';
    return <React.Fragment>
        <Container>
            <Row>
                <Col>
                    <Row>
                        <Col>
                            <SupplierFormInput id='companyName' label='Trading Name' />
                        </Col>
                        <Col>
                            <SupplierFormInput id='companyAddress' label='Address' />
                        </Col>

                    </Row>
                    <Row>
                        <Col>
                            <SupplierFormInput id='firstName' label='First Name' />
                        </Col>
                        <Col>
                            <SupplierFormInput id='lastName' label='Last Name' />
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <SupplierFormInput id='companyPhone' label='Phone' type='phone' />
                        </Col>
                        <Col>
                            <SupplierFormInput readOnly={!invite} id='email' label='Email' type='email' />
                            {isAdminOrSupplier && <Button onClick={() => {
                                push(`${route}/${values.id}/Detail/supplierSecondaryEmails`)
                            }} >Secondary Emails</Button>}
                        </Col>
                    </Row>
                    {isAdmin && <Row>
                        <Col>
                            <SupplierBooleanInput id='preferred' label='Preferred' />
                        </Col>
                        <Col>
                            <StringSelector id='clientTypes' label="Client Type" stringType list={['Generic', 'Horizon Power', 'Generic, Horizon Power', 'Generic, QGov']} />
                        </Col>
                        <Col>
                            <StringSelector id='complianceTypes' hideAllButton label="Compliances" isMulti stringType list={
                                ['IFR Operations', 'Safety Management System', 'VFR Operations', 'Maintenance Compliance']} />

                        </Col>

                    </Row>}
                    {edit ? <Row>
                        <Col style={{ color: 'red' }}>
                            <h6>Please provide either AOC Number and Date or Part 138 Number and Date</h6>
                        </Col>
                    </Row> : null}
                    <Row>
                        <Col>
                            <SupplierFormInput type="Text" id={"aocNumber"} label='AOC Number' maxLength={5} />
                        </Col>
                        <Col>
                            <FormGroup>
                                <FormLabel>AOC Issued Date</FormLabel>
                                <Col>
                                    {edit ? <React.Fragment>
                                        <Row>
                                            {/* <ErrorMessage name={"aocIssuedDate"} /> */}
                                            <DatePicker id={"aocIssuedDate"} name='aocIssuedDate' minDate={minDate} maxDate={maxDate} type='date'
                                                placeholder="AOC Issued Date" onChange={handleAocIssuedDateChange}
                                                selected={values.aocIssuedDate ? moment(values.aocIssuedDate).toDate() : undefined} />
                                        </Row>

                                    </React.Fragment> : <Row>
                                        <span>{values.aocIssuedDate ? moment(values.aocIssuedDate).format('DD/MM/YYYY') : ''}</span>
                                    </Row>}
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <FormLabel>AOC Expiry Date</FormLabel>
                                <Col>
                                    <Row>
                                        <span>{values.aocExpiryDate ? moment(values.aocExpiryDate).format('DD/MM/YYYY') : ''}</span>
                                    </Row>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <SupplierFormInput type="Text" id={"part138Number"} label='Part 138 Number' maxLength={5} />
                        </Col>
                        <Col>
                            <FormGroup>
                                <FormLabel>Part 138 Issued Date</FormLabel>
                                <Col>
                                    {edit ? <React.Fragment>
                                        <Row>
                                            {/* <ErrorMessage name={"part138IssuedDate"} /> */}
                                            <DatePicker id={"part138IssuedDate"} name='part138IssuedDate' minDate={minDate} maxDate={maxDate} type='date'
                                                placeholder="Part 138 Issued Date" onChange={handlePart138IssuedDateChange}
                                                selected={values.part138IssuedDate ? moment(values.part138IssuedDate).toDate() : undefined} />
                                        </Row>

                                    </React.Fragment> : <Row>
                                        <span>{values.part138IssuedDate ? moment(values.part138IssuedDate).format('DD/MM/YYYY') : ''}</span>
                                    </Row>}
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <FormLabel>Part 138 Expiry Date</FormLabel>
                                <Col>
                                    <Row>
                                        <span>{values.part138ExpiryDate ? moment(values.part138ExpiryDate).format('DD/MM/YYYY') : ''}</span>
                                    </Row>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col>
                    <SupplierBooleanInput id='doNotSendBidConfirmation' label='Do Not Send Me Bid Confirmation Emails' />
                </Col>
            </Row>
            <Row>
                <Col>
                    <SupplierBooleanInput id='notifyOfManifestChanges' label='Notify Me Of Manifest Changes' />
                </Col>
            </Row>
            <Row style={{ marginBottom: '1rem' }}>
                <Col>
                    <CharterType id='charterTypes' label='Charter Types' supplier />
                </Col>
            </Row>
            <Row>
                <Col>

                    {edit ? <FormGroup style={{ marginLeft: '7px' }}><FormLabel check htmlFor='locationFilterEnabled'>
                        <Input type='checkbox' id='locationFilterEnabled'
                            name='locationFilterEnabled' placeholder="Supplier Location"
                            checked={values.locationFilterEnabled} onChange={handleChangeEmailLocationFilter} />Enable filtering Email notifications by location
                    </FormLabel></FormGroup> : <FormGroup>
                        <FormLabel>Filtering Email notifications by location: 
                        </FormLabel><FormValue>{values.locationFilterEnabled ? ' Enabled' : ' Disabled'}</FormValue></FormGroup>}

                </Col>
            </Row>
            {values.locationFilterEnabled ? <Row>
                <Col>
                    <SupplierLocationSelector isMulti id='filterLocation' label='Service  Regions' />
                </Col>
            </Row> : null}
            <Row>
                <Col>

                    {edit ? <FormGroup style={{ marginLeft: '7px' }}> <FormLabel check htmlFor='passengerRangeFilterEnabled'>
                        <Input type='checkbox' id='passengerRangeFilterEnabled'
                            name='passengerRangeFilterEnabled' placeholder="Passenger Range"
                            checked={values.passengerRangeFilterEnabled} onChange={handleChangePassengerRange} />Enable filtering Email notifications by passenger numbers
                    </FormLabel> </FormGroup> : <FormGroup> <FormLabel>
                        Filtering Email notifications by Passenger Numbers: </FormLabel>
                        <FormValue>{values.passengerRangeFilterEnabled ? ' Enabled' : ' Disabled'} </FormValue>
                    </FormGroup>
                    }

                </Col>
            </Row>
            {values.passengerRangeFilterEnabled ? <Row>
                <Col>
                    <SupplierFormInput id='minPassengers' label='Min Passengers' />
                </Col>
                <Col>
                    <SupplierFormInput id='maxPassengers' label='Max Passengers' />
                </Col>
            </Row> : null}

        </Container >
        <SecondaryEmails supplier={values} onClose={() => { push(`${route}/${values.id}/Detail`); }} open={location.pathname.endsWith('supplierSecondaryEmails')} />
    </React.Fragment >
};
export default Supplier;




